module.exports = __webpack_public_path__ + "img/240-1b1438.png";